import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import ServiceDetailHero from '../components/ServiceDetailHero';
import ServiceDetailContent from '../components/ServiceDetailContent';
import ServiceDetailFeatures from '../components/ServiceDetailFeatures';
import ServiceDetailProcess from '../components/ServiceDetailProcess';
import ServiceDetailPricing from '../components/ServiceDetailPricing';
import CTASection from '../../home/components/CTASection';
import { useSEO } from '../../../utils/seo';

const WebDesignPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Web Tasarımı & Landing Page - Sigorta360 | CRM Entegrasyonlu Web Sitesi',
    description: 'Sigorta acenteleri için CRM entegrasyonlu, dönüşüm odaklı web sitesi ve landing page tasarımı. Mobil uyumlu, hızlı ve SEO dostu. 25.000₺\'den başlayan paketler.',
    keywords: 'sigorta web tasarım, sigorta web sitesi, landing page tasarımı, CRM entegrasyonu, responsive web',
    canonical: `${siteUrl}/hizmetler/web-tasarim`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Web Sitesi & Landing Page Tasarımı',
      description: 'CRM entegrasyonlu, dönüşüm odaklı web sitesi ve landing page geliştirme hizmeti',
      provider: {
        '@type': 'Organization',
        name: 'Sigorta360',
        url: siteUrl
      },
      areaServed: {
        '@type': 'Country',
        name: 'Türkiye'
      },
      offers: {
        '@type': 'AggregateOffer',
        priceCurrency: 'TRY',
        lowPrice: '25000',
        highPrice: '47500',
        offerCount: '3'
      }
    }
  });

  const heroData = {
    category: 'Web Geliştirme',
    title: 'Web Sitesi & Landing Page Tasarımı',
    description: 'CRM entegrasyonlu, dönüşüm odaklı web siteleri ve landing page tasarımları geliştiriyoruz. Mobil uyumlu, hızlı ve SEO dostu web çözümleri ile dijital varlığınızı güçlendirin.',
    image: 'https://public.readdy.ai/ai/img_res/97ae3125d55f6cad386e152f98c4cac6.jpg',
  };

  const contentData = {
    overview: 'Web siteniz, dijital dünyadaki vitrininizdir. Sigorta360 olarak, sadece güzel görünen değil, aynı zamanda dönüşüm sağlayan, CRM sistemlerinizle entegre, hızlı ve kullanıcı dostu web siteleri tasarlıyoruz.',
    benefits: [
      {
        icon: 'ri-smartphone-line',
        title: 'Mobil Uyumlu',
        description: 'Tüm cihazlarda mükemmel görünüm ve kullanıcı deneyimi sağlayan responsive tasarım.',
      },
      {
        icon: 'ri-speed-line',
        title: 'Hızlı Yükleme',
        description: 'Optimize edilmiş kod ve görseller ile 2 saniyeden kısa yükleme süreleri.',
      },
      {
        icon: 'ri-search-line',
        title: 'SEO Uyumlu',
        description: 'Google\'da üst sıralarda yer almanız için SEO optimizasyonu yapılmış yapı.',
      },
      {
        icon: 'ri-exchange-line',
        title: 'Yüksek Dönüşüm',
        description: 'Kullanıcı davranışlarına göre optimize edilmiş, dönüşüm odaklı tasarım.',
      },
    ],
  };

  const featuresData = {
    title: 'Web Tasarım Hizmetlerimiz',
    features: [
      {
        icon: 'ri-layout-line',
        title: 'Kurumsal Web Sitesi',
        description: 'Markanızı yansıtan, profesyonel kurumsal web sitesi tasarımı. Hakkımızda, hizmetler, referanslar, blog ve iletişim sayfaları.',
      },
      {
        icon: 'ri-pages-line',
        title: 'Landing Page',
        description: 'Kampanyalarınız için özel tasarlanmış, yüksek dönüşüm odaklı landing page\'ler. A/B test desteği.',
      },
      {
        icon: 'ri-file-list-line',
        title: 'Teklif Formları',
        description: 'CRM entegrasyonlu, kullanıcı dostu teklif formları. Otomatik e-posta bildirimleri ve lead takibi.',
      },
      {
        icon: 'ri-article-line',
        title: 'Blog & İçerik',
        description: 'SEO uyumlu blog sistemi, içerik yönetim paneli, kategori ve etiket yapısı.',
      },
      {
        icon: 'ri-whatsapp-line',
        title: 'WhatsApp Entegrasyonu',
        description: 'WhatsApp Business API entegrasyonu, otomatik mesajlaşma, müşteri destek sistemi.',
      },
      {
        icon: 'ri-dashboard-line',
        title: 'Yönetim Paneli',
        description: 'Kolay kullanımlı admin paneli, içerik güncelleme, form yönetimi, istatistik takibi.',
      },
    ],
  };

  const processData = {
    title: 'Web Tasarım Sürecimiz',
    steps: [
      {
        number: '01',
        title: 'Keşif & Planlama',
        description: 'İhtiyaç analizi, hedef kitle belirleme, site haritası oluşturma, içerik planlaması.',
      },
      {
        number: '02',
        title: 'Tasarım',
        description: 'Wireframe oluşturma, görsel tasarım, marka kimliğine uygun renk ve tipografi seçimi.',
      },
      {
        number: '03',
        title: 'Geliştirme',
        description: 'Frontend ve backend kodlama, CRM entegrasyonu, form yapılandırması, test ortamı kurulumu.',
      },
      {
        number: '04',
        title: 'Test & Optimizasyon',
        description: 'Cihaz testleri, hız optimizasyonu, SEO kontrolü, güvenlik testleri.',
      },
      {
        number: '05',
        title: 'Yayınlama & Destek',
        description: 'Domain ve hosting kurulumu, site yayınlama, eğitim, sürekli destek ve güncelleme.',
      },
    ],
  };

  const pricingData = {
    title: 'Web Tasarımı (CRM Destekli) Paketleri',
    packages: [
      {
        name: 'Başlangıç',
        price: '25.000',
        period: 'proje',
        description: '1-5 sayfa kurumsal site',
        features: [
          '1-5 Sayfa kurumsal web sitesi',
          'Responsive (mobil uyumlu) tasarım',
          'Temel CRM form entegrasyonu',
          'SSL sertifikası',
          'Hız optimizasyonu',
          'Temel SEO ayarları',
          'Google Analytics entegrasyonu',
          '3 Ay teknik destek',
        ],
        highlighted: false,
      },
      {
        name: 'Profesyonel',
        price: '35.000',
        period: 'proje',
        description: '5-10 sayfa + otomasyon',
        features: [
          '5-10 Sayfa gelişmiş web sitesi',
          'Gelişmiş UI/UX tasarım',
          'CRM otomasyon entegrasyonu',
          'Form tetiklemeleri ve akışları',
          'Kullanıcı akışı optimizasyonu',
          'Dönüşüm odaklı tasarım',
          'Blog sistemi',
          'Gelişmiş SEO optimizasyonu',
          '6 Ay teknik destek',
        ],
        highlighted: true,
      },
      {
        name: 'Premium',
        price: '47.500',
        period: 'proje',
        description: '10+ sayfa + API entegrasyon',
        features: [
          '10+ Sayfa premium web sitesi',
          'Çoklu dil desteği',
          'Gelişmiş API entegrasyonları',
          'Özel CRM çözümleri',
          'Detaylı SEO ve hız testleri',
          'Premium performans optimizasyonu',
          'Gelişmiş analitik entegrasyonları',
          'Özel özellik geliştirmeleri',
          '12 Ay premium destek',
        ],
        highlighted: false,
      },
    ],
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ServiceDetailHero data={heroData} />
        <ServiceDetailContent data={contentData} />
        <ServiceDetailFeatures data={featuresData} />
        <ServiceDetailProcess data={processData} />
        <ServiceDetailPricing data={pricingData} />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default WebDesignPage;
